import React from "react";
import {
  getClassesBasedOnStatus,
  getFieldFieldValue,
  getStatusByStatusId,
  isCivilDefenseUser,
  isRtl,
} from "src/utils/helpers";
import { ReactComponent as Edit } from "src/assets/icons/edit.svg";
import { useSelector, useDispatch } from "react-redux";
import { initializeSendRequestToOwnerPopupData } from "src/redux/slices/bMCProfileSlice";
import { StatusesWithHoldReason } from "src/resources/enum";

interface StatusColumnTemplateProps {
  statuses: any[];
  rowData: any;
  setUpdateStatusPopupOpen: (rowData: any) => void;
  statusIdentifier?: string;
}

const StatusColumnTemplate: React.FC<StatusColumnTemplateProps> = ({
  statuses,
  rowData,
  setUpdateStatusPopupOpen,
  statusIdentifier = rowData?.statusId,
}) => {
  const dispatch = useDispatch();
  const status = getStatusByStatusId(statuses, statusIdentifier);

  const language = useSelector((state: any) => state.lookup.language);
  let onHoldReason = rowData.onHoldReasonEn;
  if (isRtl(language)) {
    onHoldReason = rowData.onHoldReasonAr;
  }
  const handleEditStatusClick = (e: any) => {
    e.stopPropagation();
    setUpdateStatusPopupOpen(rowData);
    dispatch(
      initializeSendRequestToOwnerPopupData({
        systemServiceId: rowData.systemServiceId,
        serviceTerritoryId: rowData.serviceTerritoryId,
        propertyId: rowData.propertyId,
        requestReferenceNumber: rowData.id || rowData.appointmentId,
        appointmentId: rowData.appointmentId,
        caseId: rowData.id,
      })
    );
  };
  return (
    <div
      className="d-flex gap-1 align-items-center "
      title={
        rowData.statusEn?.toLowerCase() ===
        StatusesWithHoldReason.PendingOwnerApproval
          ? onHoldReason
          : ""
      }
    >
      <span className={`me-2 circle ${getClassesBasedOnStatus(status)}`}></span>
      <span>{getFieldFieldValue(status)}</span>

      {rowData.statusEn &&
      rowData.statusEn !== "Completed" &&
      !isCivilDefenseUser() ? (
        <span className="edit-icon mx-2">
          <Edit onClick={handleEditStatusClick} />
        </span>
      ) : null}
    </div>
  );
};

export default StatusColumnTemplate;
